export * from './filters'
export * from './batch'
export * from './createBatch'
export * from './globalSearch'
export * from './connections'
export * from './settings'
export * from './home'
export * from './onboarding'
export * from './stripe'
export * from './posthog'
export * from './inventory'
export * from './imports'
export * from './listings'
export * from './events'
export * from './messages'

export const AVATAR_MAX_SIZE = 5242880 // B (in binary) - 5MB

export const DEFAULT_TIME_VALUE = 7

export const PASSWORD_RULES = [
  { text: 'a minimum of 8 characters', regex: /.{8,128}/ },
  { text: 'an upper case letter', regex: /[A-Z]/ },
  { text: 'a number', regex: /\d/ },
  { text: 'a special character', regex: /\W/ },
]

export const FEEDBACK_TABS = [
  { icon: 'heroicons:question-mark-circle', text: 'Question', type: 'question' },
  { icon: 'heroicons:chat-bubble-left-ellipsis', text: 'Feedback', type: 'feedback' },
  { icon: 'octicon:bug-24', text: 'Bug', type: 'bug' },
]

export const FEEDBACK_REPORT_AREAS = [
  'App Performance',
  'Authentication (Log In / Sign Up)',
  'Subscriptions & Billing',
  'Magic Scan (Import using Image)',
  'Card Database Matching',
  'Batch Management',
  'Card Details',
  'Exporting to Channels (eBay / Shopify)',
  'Title & Description Templates',
]

export const COUNTRIES = [
  { name: 'United States', abbreviation: 'US' },
]

export const TAILWIND_FONT_SIZES = {
  1: 'text-3xl',
  2: 'text-2xl',
  3: 'text-xl',
  4: 'text-lg',
  5: 'text-base',
  6: 'text-sm',
}

export const MONTHS = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
]

export const DEGREE_OF_ROTATION = 90

export const WEIGHT_UNITS = [
  { label: 'oz', value: 'ounce' },
  { label: 'lbs', value: 'pound' },
  { label: 'g', value: 'gram' },
  { label: 'kg', value: 'kilogram' }
]

export const HAZMAT_OPTIONS = [
  { label: 'No Hazardous Materials', value: 0 },
  { label: 'Hazardous Materials', value: 1 }
]

export const PRICING_RESEARCH_MARKET_SOURCE = {
  MEDIAN: 'Med',
  AVG: 'Avg',
  LAST_SALE: 'Last Sale',
  ESTIMATION: 'Est',
  AVERAGE: 'Avg',
}

export const CALCULATION_TYPES = ['Increase', 'Decrease']
export const CALCULATION_METHODS = ['$', '%']

export const ROUNDING_OPTIONS = ['Dollar', 'Half Dollar']

export const APPLIED_MARKET_PRICE_SOURCES = ['Apply Market Price', 'Apply Purchase Price']

export const BULK_PRICING_CONFIGS = {
  price_adjustment_type: CALCULATION_TYPES[0],
  amount_to_price: 0,
  calculated_method: false,
  round_to_nearest: false,
  round_to_nearest_type: null,
  add_minimal_price: false,
  minimal_price: 0,
}

export const DEFAULT_TOAST_NOTIFICATION = {
  show: false,
  message: '',
  type: 'success',
  title: ''
}
